var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"inspect-extand"},[(_vm.dataList.length !== 0)?_c('Table',{attrs:{"border":"","columns":_vm.columnsSchema,"data":_vm.dataList},scopedSlots:_vm._u([{key:"type",fn:function(ref){
var row = ref.row;
var index = ref.index;
return [_vm._v(_vm._s(_vm.taskType[row.type]))]}},{key:"time",fn:function(ref){
var row = ref.row;
var index = ref.index;
return [_vm._v(_vm._s(_vm.formatTime(row.lock_etime - row.lock_stime)))]}}],null,false,1505187623)}):_c('div',{staticClass:"empty-wrap"},[_c('i',{staticClass:"empty"}),_c('p',{staticClass:"empty-text"},[_vm._v("暂无数据")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }